"use client";

import { usePathname } from "next/navigation";
import { useEffect, useMemo } from "react";

export const SectionDetector = () => {
  const pathname = usePathname();

  const observer = useMemo(() => {
    if (typeof window !== "undefined")
      return new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const id = entry.target.id;
              window.history.replaceState(window.history.state, "", `#${id}`);
            }
          });
        },
        { threshold: 0.1, rootMargin: "-200px 0px -50% 0px" }
      );
  }, []);

  useEffect(() => {
    const sections = document.querySelectorAll("section[id]");

    sections.forEach((section) => {
      observer?.observe(section);
    });

    return () => {
      sections.forEach((section) => {
        observer?.unobserve(section);
      });
    };
    /**
     * Note:
     * We need to query and observe the sections
     * every time when the route (pathname) changes
     */
  }, [observer, pathname]);

  return <></>;
};
